import Button from 'components/Button'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import link from 'infra/link'
import OpportunitiesListEmpty from 'opportunities/components/OpportunitiesListEmpty'
import { observer } from 'mobx-react'
import { SearchState } from 'opportunities/OpportunitiesSearchViewModel'
import OpportunitiesViewModel from 'opportunities/OpportunitiesViewModel'
import * as React from 'react'
import { Id } from 'types/definitions'
import OpportunityListItem from './OpportunityListItem'

interface OpportunitiesListProps {
  vm: OpportunitiesViewModel
  showWorkspaceInfo: boolean
}

export default observer(function OpportunitiesList({
  vm,
  showWorkspaceInfo,
}: OpportunitiesListProps) {
  return (
    <div>
      <div>
        {vm.opportunities.map((op) => (
          <OpportunityListItem
            key={Id.assert(op.opportunity.id)}
            opportunity={op}
            onSelect={vm.detailsVM.select}
            showWorkspaceInfo={showWorkspaceInfo}
            selected={vm.detailsVM.selected?.opportunityId === op.opportunityId}
          />
        ))}
        {!vm.searcher.scroller.fetch.pending &&
          vm.opportunities.length === 0 &&
          vm.searcher.scroller.isDone && <OpportunitiesEmpty vm={vm} />}
      </div>
      <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
    </div>
  )
})

interface OpportunitiesEmptyProps {
  vm: OpportunitiesViewModel
}

const OpportunitiesEmpty = observer(function OpportunitiesEmpty({
  vm,
}: OpportunitiesEmptyProps) {
  // Length check counters case where realtime event comes in.
  if (
    vm.searcher.searchState === SearchState.CompletelyEmpty &&
    vm.opportunities.length === 0
  ) {
    return (
      <OpportunitiesListEmpty
        title="Looking a little empty? Get notified when new opportunities appear."
        imageSrc={require('assets/images/img_empty.svg')}
        subtitle={
          <>
            Make sure you have your notification preferences set up correctly.
          </>
        }
      >
        <Button type="primary" to={link.profileNotifications()}>
          Go To Notification Preferences
        </Button>
      </OpportunitiesListEmpty>
    )
  }

  return (
    <OpportunitiesListEmpty
      onClearSearchFilterClick={vm.searcher.clearFilters}
    />
  )
})
